import { ShallowSounding } from "./voyage-routing-model";

export enum AlertType
{
    OutdatedPosition = "outdated-position",
    OutdatedPlan = "outdated-plan",
    OutdatedWeather = "outdated-weather",
    OutdatedENC = "outdated-enc",
    PlanRecalculatedETAChange = "plan-recalculated-eta-change",
    PlanRecalculatedNewForecast = "plan-recalculated-new-forecast",
    PlanRecalculatedPilotOff = "plan-recalculated-pilot-off",
    PlanRecalculatedGeneric = "plan-recalculated-generic",
    ParametricRoll = "parametric-roll",
    HeavyWeather = "heavy-weather",
    AlarmReminder = "alarm-reminder",
    SubmittedAlarm = "submitted-alarm",
    EtaDeviation = "eta-deviation",
    NoPlanEtd = "no-plan-etd",
    WNIReports = "wni-reports",
    NoPlanPreEtd = "no-plan-pre-etd",
    basicPlanAvailable = "basic-plan-available",
    slowNetworkDetected = "slow-network-detected",
    BestPracticeRouteUpdated = "best-practice-route-updated",
    CounterProposalNotification = "counter-proposal-notification",
    WeatherRoutingAdviceAvailable = "weather-routing-advice-available",
    WeatherRoutingAdviceActionNeeded = "weather-routing-advice-action-needed",
    EtaChangeRemindLater = "eta-change-remind-later",
    LoadstarUpdated = "loadstar-updated",
    SuccessAlert = 'success-alert',
    OpenOceanRouteReadinessWarning = "open-ocean-route-readiness-warning",
    ShallowSoundingsWarning = "shallow-soundings-warning",
    StarRouteNegativeUkcWarning = "star-route-negative-ukc-warning"
}

export interface VesselAlert
{
    id: string;
    message: string;
    title?: string;
    type?: AlertType;
    time?: string;
    reportId?: number;
    reportType?: string;
    scheduleId?: string;
    shallowSoundings?: ShallowSounding[];
}

export abstract class VesselAlertsModelBase extends EventTarget
{
    abstract getAlerts(imo: number): VesselAlert[];
    abstract getAlert(imo: number, alertId: string): VesselAlert|null;
    abstract addAlert(imo: number, alert: VesselAlert): void;
    abstract removeAlert(imo: number, alertId: string): void;
    abstract clearAlerts(imo: number): void;
    abstract removeAlertsByType(imo: number, alertId: AlertType|string): void
}

let VesselAlertsModel: VesselAlertsModelBase|null = null;

function setVesselAlertsModel(model: VesselAlertsModelBase)
{
    VesselAlertsModel = model;
}

export { VesselAlertsModel, setVesselAlertsModel };
